<unity-outside-container>
  <kendo-stacklayout class="outside-form" orientation="vertical" [gap]="15">
    <h5>Sorry, this account has been disabled.</h5>
    <span>If this is unexpected, please contact your administrator for more information.</span>
    <button kendoButton themeColor="primary" routerLink="/login" type="submit">Back to Login</button>
  </kendo-stacklayout>
</unity-outside-container>
